import { createClient } from "@urql/preact";

const API_URL = "https://ury.org.uk/api/graphql";
export const API_KEY = "5CD9F9214A05F5061AA5A31C6656FDA9E080AD64E50FDA8132F7921B8BEDBF324D7F8B6093D730942ECA0CF24F9E75DBFBDC6E26C2B1166D7155F2299075B0E6";

export const Client = createClient({
    url: API_URL + "?api_key=" + API_KEY + "&debug=true"
});
